export default "__VITE_ASSET__0aZ4dRS7__"